__turbopack_context__.v({
  "className": "hanken_grotesk_18b4c1d6-module__ZKF0Jq__className",
  "variable": "hanken_grotesk_18b4c1d6-module__ZKF0Jq__variable",
});
